function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "birds"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M154.2,73.9c0,0,10.3-6.4,14.1-7.6c3.6-1.2,14.7-2,14.7-2s-9.1-11.1-18.3-5.4S154.4,70.4,154.2,73.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M152.3,75.2c0,0,12.2,0.1,16,1c3.7,0.9,13.5,6.1,13.5,6.1S180,68,169.2,68C158.4,68,154.3,72.3,152.3,75.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M149.6,76.5c0,0,1.2-16.1,2.8-21.1c1.5-4.8,9.3-17.4,9.3-17.4s-19.1,1.2-20.1,15.5S146,73.6,149.6,76.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M151.3,77.5c0,0,7.6-14.3,11.1-18.2c3.3-3.7,15.6-12.1,15.6-12.1s-17.9-6.7-24.6,6 C146.6,65.9,149.2,73.4,151.3,77.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M118.8,88.9c0,0,0.4-10.3,8.7-12.3c8.3-2,24.5-2.3,36,9.4c8.7,8.8,9.4,32.3,7,37.3c-9.2,19.2-4.6,33-4.1,34.4 s-24,2-24,2s-3.2-29.3-2.2-35"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M158.4,116.7c-9.6,11.8-29,8.4-34.4,3.5c-0.2-0.2-0.3-0.3-0.5-0.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M148.7,109.5c-17.7-4.8-23.6,0.2-26.7,2.1c-3.1,1.9-9,3.7-18.8,3.3c-5.8-0.2-13.2,4.8-13.2,4.8 c3.5,4.7,9.9,5.1,18.3,4.1c8.2-0.9,25.4-7.5,28.9-9.7C140.7,112,148.1,112.2,148.7,109.5c0.6-2.7-14.9-5.9-20.4-8.5 c-5.5-2.6-9.5-12.1-9.5-12.1c-1.9,5.9-7.3,8.4-13.5,7c-9.1-2-17.5,1.7-21.4,8.6c-3.9,6.9,1.3,17.6,1.3,17.6c3-1.4,4.8-2.3,4.8-2.3 "
}), /*#__PURE__*/React.createElement("circle", {
  className: "st3",
  cx: 136.7,
  cy: 92.9,
  r: 2.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 136.7,
  cy: 92.9,
  r: 6.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M591.1,73.9c0,0,10.3-6.4,14.1-7.6c3.6-1.2,14.7-2,14.7-2s-9.1-11.1-18.3-5.4S591.3,70.4,591.1,73.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M589.2,75.2c0,0,12.2,0.1,16,1c3.7,0.9,13.5,6.1,13.5,6.1S616.8,68,606.1,68C595.3,68,591.2,72.3,589.2,75.2z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M586.5,76.5c0,0,1.2-16.1,2.8-21.1c1.5-4.8,9.3-17.4,9.3-17.4s-19.1,1.2-20.1,15.5 C577.5,67.8,582.9,73.6,586.5,76.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M588.2,77.5c0,0,7.6-14.3,11.1-18.2c3.3-3.7,15.6-12.1,15.6-12.1s-17.9-6.7-24.6,6S586.1,73.4,588.2,77.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M555.7,88.9c0,0,0.4-10.3,8.7-12.3c8.3-2,24.5-2.3,36,9.4c8.7,8.8,9.4,32.3,7,37.3c-9.2,19.2-4.6,33-4.1,34.4 s-24,2-24,2s-3.2-29.3-2.2-35"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M595.3,116.7c-9.9,12.2-30.3,8.2-34.9,3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M585.6,109.5c-17.7-4.8-23.6,0.2-26.7,2.1c-3.1,1.9-9,3.7-18.8,3.3c-5.8-0.2-13.2,4.8-13.2,4.8 c3.5,4.7,9.9,5.1,18.3,4.1c8.2-0.9,25.4-7.5,28.9-9.7C577.5,112,585,112.2,585.6,109.5c0.6-2.7-14.9-5.9-20.4-8.5 c-5.5-2.6-9.5-12.1-9.5-12.1c-1.9,5.9-7.3,8.4-13.5,7c-9.1-2-17.5,1.7-21.4,8.6c-3.9,6.9,1.3,17.6,1.3,17.6c3-1.4,4.8-2.3,4.8-2.3 "
}), /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 573.5,
  cy: 92.9,
  r: 6.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 571.4,
  y1: 91.2,
  x2: 575.4,
  y2: 94.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 571.7,
  y1: 94.7,
  x2: 575.2,
  y2: 90.9
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "slow"
}, /*#__PURE__*/React.createElement("g", {
  id: "Q1a"
}, /*#__PURE__*/React.createElement("line", {
  className: "st6",
  x1: 257.2,
  y1: 72.8,
  x2: 265.1,
  y2: 65.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st6",
  x1: 257.3,
  y1: 66,
  x2: 264.4,
  y2: 74.1
})), /*#__PURE__*/React.createElement("g", {
  id: "Q1b"
}, /*#__PURE__*/React.createElement("line", {
  className: "st6",
  x1: 293.6,
  y1: 124.4,
  x2: 301.5,
  y2: 117.2
}), /*#__PURE__*/React.createElement("line", {
  className: "st6",
  x1: 293.8,
  y1: 117.6,
  x2: 300.8,
  y2: 125.7
})), /*#__PURE__*/React.createElement("g", {
  id: "Q1d"
}, /*#__PURE__*/React.createElement("line", {
  className: "st7",
  x1: 345.7,
  y1: 79.3,
  x2: 353.7,
  y2: 72
}), /*#__PURE__*/React.createElement("line", {
  className: "st7",
  x1: 345.9,
  y1: 72.4,
  x2: 353,
  y2: 80.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Q1e"
}, /*#__PURE__*/React.createElement("line", {
  className: "st7",
  x1: 354.1,
  y1: 133.2,
  x2: 362.1,
  y2: 125.9
}), /*#__PURE__*/React.createElement("line", {
  className: "st7",
  x1: 354.3,
  y1: 126.4,
  x2: 361.4,
  y2: 134.4
})), /*#__PURE__*/React.createElement("circle", {
  id: "Q1c",
  className: "st8",
  cx: 312.2,
  cy: 52.2,
  r: 4.3
}), /*#__PURE__*/React.createElement("circle", {
  id: "Q1f",
  className: "st9",
  cx: 398.9,
  cy: 116.4,
  r: 4.3
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "questionMark"
}, /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M339.3,85.2c0-9.5,7.7-17.2,17.2-17.2s17.2,7.7,17.2,17.2s-17.2,18-17.2,23.4l0.2,15.4"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st13",
  cx: 356.5,
  cy: 141.6,
  r: 6.4
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "route"
}, /*#__PURE__*/React.createElement("line", {
  id: "route1",
  className: "st10",
  x1: 217.8,
  y1: 105.5,
  x2: 480.5,
  y2: 105.5
}), /*#__PURE__*/React.createElement("polyline", {
  id: "route2",
  className: "st10",
  points: "217.8,106.5 252,137.8 287.1,84.4 311.8,119.5 348.7,94.6 403.7,143.7 442,107.9  480.5,106.5  "
}), /*#__PURE__*/React.createElement("polyline", {
  id: "arrow",
  className: "st10",
  points: "466.5,119.6 481,107 468.6,96.3  "
}));

var SvgQ1Svg = function SvgQ1Svg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Q1svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 714.5 202",
    style: {
      enableBackground: "new 0 0 714.5 202"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQ1Svg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Q1svg.e50a5623.svg";
export { ForwardRef as ReactComponent };